import React, { createContext, useContext, useEffect, useRef } from 'react';

export const DialogBusyContext=createContext({busy:false,closeLabel:'Close'});
export function Dialog({title,children,onClose,busy,closeLabel}) {
  const dialogContext=useContext(DialogBusyContext);
  const isBusy=busy ?? dialogContext.busy;
  const panelRef=useRef(null);
  const onCloseRef=useRef(onClose);
  const busyRef=useRef(isBusy);
  onCloseRef.current=onClose;
  busyRef.current=isBusy;
  useEffect(() => {
    const previous=document.activeElement;
    const panel=panelRef.current;
    (panel?.querySelector('[autofocus],input:not([type="hidden"]),button:not(:disabled)'))?.focus();
    const close=e=>{
      if(e.key==='Escape'){e.preventDefault();if(!busyRef.current)onCloseRef.current();}
      if(e.key!=='Tab' || !panel)return;
      const focusables=Array.from(panel.querySelectorAll('button:not(:disabled),input:not(:disabled),textarea:not(:disabled),select:not(:disabled),a[href]')).filter(el=>el.getClientRects().length);
      if(!focusables.length)return;
      const first=focusables[0],last=focusables[focusables.length-1];
      if(e.shiftKey && (document.activeElement===first || !panel.contains(document.activeElement))){e.preventDefault();last.focus();}
      else if(!e.shiftKey && (document.activeElement===last || !panel.contains(document.activeElement))){e.preventDefault();first.focus();}
    };
    document.addEventListener('keydown',close);
    return () => {document.removeEventListener('keydown',close);if(previous?.isConnected)previous.focus();};
  },[]);
  return <div className="ws-dialog-backdrop" onMouseDown={e => {if(!isBusy && e.target === e.currentTarget) onClose();}}>
    <section className="ws-dialog" ref={panelRef} role="dialog" aria-modal="true" aria-label={title} aria-busy={isBusy} onClickCapture={e=>{if(isBusy && e.target.closest('button')){e.preventDefault();e.stopPropagation();}}}>
      <div className="ws-between"><h2>{title}</h2><button type="button" className="ws-textbtn" disabled={isBusy} onClick={onClose} aria-label={closeLabel || dialogContext.closeLabel}>×</button></div>
      {children}
    </section>
  </div>;
}

export const Skeleton = () => <div aria-busy="true" aria-label="Loading"><div className="ws-skeleton"/><div className="ws-skeleton"/><div className="ws-skeleton"/></div>;
export const ErrorBlock = ({error,t,retry}) => <div className="ws-error" role="alert">{t[error?.code] || t.unknownError} {retry && <button type="button" className="ws-textbtn" onClick={retry}>{t.retry}</button>}</div>;
export const dateLabel = (value,lang) => {
  if (!value) return '';
  const date = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00Z` : value);
  return Number.isNaN(date.valueOf()) ? '' : new Intl.DateTimeFormat(({en:'en-CA',fr:'fr-CA',zh:'zh-CN'}[lang] || 'en-CA'),{year:'numeric',month:'short',day:'numeric'}).format(date);
};
export function exactDemoDiff(a,b) {
  const before = (a?.sourceText || '').split(/\n\s*\n/).map(s=>s.trim()).filter(Boolean);
  const after = (b?.sourceText || '').split(/\n\s*\n/).map(s=>s.trim()).filter(Boolean);
  const removed = before.map((text,index)=>({text,index,versionId:a?.id})).filter(s=>!after.includes(s.text));
  const added = after.map((text,index)=>({text,index,versionId:b?.id})).filter(s=>!before.includes(s.text));
  const changes = [];
  for (let i=0;i<Math.max(removed.length,added.length);i++) changes.push({kind:removed[i] && added[i] ? 'changed' : added[i] ? 'added' : 'removed',before:removed[i] || null,after:added[i] || null,category:'general',needsReview:true});
  return {method:'text-diff',changes};
}